import { render } from "./Maps.vue?vue&type=template&id=ff3274f8"
import script from "./Maps.vue?vue&type=script&lang=js"
export * from "./Maps.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Master\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__